exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".col-12.text-center {\n  padding: 30px; }\n\n.container-page {\n  width: 16.54in;\n  max-width: 16.54in;\n  height: 11.69in;\n  max-height: 11.69in;\n  margin: 0 auto;\n  padding: 30px;\n  overflow: hidden; }\n\n.title-slide {\n  text-transform: uppercase;\n  margin: 0;\n  font-size: 25px;\n  margin-top: 10px; }\n\nhr.top {\n  background-image: linear-gradient(135deg, #0083f4 70%, black 30%);\n  height: 3px; }\n\n.text-desc {\n  font-size: 18px;\n  font-weight: bold;\n  color: #c00000; }\n\n.card-body {\n  position: relative; }\n\n.img-brand {\n  position: absolute;\n  bottom: 0;\n  width: 10rem;\n  height: auto;\n  right: 4rem;\n  bottom: 0; }\n\n.table-custom thead th {\n  background: #1e7e34;\n  color: white; }\n\n.container-content {\n  height: 740px;\n  border: solid #0083f4 2px;\n  border-radius: 5px;\n  padding: 30px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/featured-content/app-featured-content.component.scss
// module id = ../../../../../src/app/views/reports-component/featured-content/app-featured-content.component.scss
// module chunks = main